import { __awaiter } from "tslib";
import { useAdsCore } from '@slickdeals/ads-core';
export const initPage = () => __awaiter(void 0, void 0, void 0, function* () {
    useAdsCore().initAdStack();
});
